import styled from 'styled-components';
import { rem } from 'polished';
import customMedia from '../../../../config/themes/variables/breakpoints';

/* Capa para el buscador en los modales */
export const StyledSearchInput = styled.div`
  margin: ${rem('10px')} 0 ${rem('10px')};
  width: 100%;
  position: fixed;
  bottom: 0;
  margin: ${rem('10px')} 0 0;
  ${customMedia.greaterThan('large')`
    width: ${rem('440px')};
    position: relative;
    margin-bottom: ${rem('10px')};
  `};
`;
